import { AutoScalingGroupProperties } from 'models/auto-scaling-group';
import { rest } from 'utils';

const baseUrl = 'autoscaling';

export default {
  group: {
    getAll: () => rest.get({ baseUrl, url: '/groups?depth=2' }),
    create: (properties = new AutoScalingGroupProperties()) => rest.post({ baseUrl, url: '/groups', body: { properties } }),
    get: ({ id }) => rest.get({ baseUrl, url: `/groups/${id}?depth=2` }),
    update: ({ id, properties = new AutoScalingGroupProperties() }) => (
      rest.put({ baseUrl, url: `/groups/${id}`, body: { properties } })
    ),
    delete: ({ id }) => rest.delete({ baseUrl, url: `/groups/${id}` }),
    getAllActions: ({ groupId }) => rest.get({ baseUrl, url: `/groups/${groupId}/actions?depth=2` }),
    getAction: ({ groupId, actionId }) => rest.get({ baseUrl, url: `/groups/${groupId}/actions/${actionId}?depth=2` }),
    scaleIn: ({ groupId }) => rest.post({ baseUrl, url: `/groups/${groupId}/scalein`, body: {} }),
    scaleOut: ({ groupId }) => rest.post({ baseUrl, url: `/groups/${groupId}/scaleout`, body: {} }),
    getAllServers: ({ groupId }) => rest.get({ baseUrl, url: `/groups/${groupId}/servers?depth=2` }),
    getServer: ({ groupId, serverId }) => rest.get({ baseUrl, url: `/groups/${groupId}/servers/${serverId}?depth=2` }),
  },
};
